import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
// import { get } from 'lodash'
import { injectIntl } from 'react-intl'
import { Title, Form } from 'components/layout'
import { Button } from 'components/misc'
import { Input, Textarea } from 'components/fields'
import { form } from 'helpers/decorators'
import { apiPersons } from 'helpers/decorators/api'
import { sendEmailValidate } from 'models/emails'

@injectIntl
@apiPersons()
@form({
  form: 'send-test-email-form',
  validate: sendEmailValidate
})
class EmailSend extends Component {
  static propTypes = {
    personId: PropTypes.number.isRequired,
    intl: PropTypes.object,
    onCancel: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func,
    initialize: PropTypes.func,
    submitting: PropTypes.bool,
    getPersonEmailPrefs: PropTypes.func,
    sendPersonEmail: PropTypes.func
  }

  state = {
    isLoading: false
  }

  componentDidMount = () => {
    this.setState({
      isLoading: true
    })
    this.props
      .getPersonEmailPrefs(this.props.personId)
      .then(({ body } = {}) => {
        this.props.initialize({
          email: body.email,
          body: body.body,
          subject: body.subject
        })
        this.setState({
          isLoading: false
        })
      })
      .catch(() => {
        this.setState({
          isLoading: false
        })
      })
  }

  render() {
    const { handleSubmit, submitting, intl } = this.props
    const { isLoading } = this.state

    return (
      <Form
        loading={isLoading}
        onSubmit={handleSubmit(this.props.sendPersonEmail)}
      >
        <Title
          h2
          intlKey="moduleTitle.send_test_email"
          className="text--center"
        >
          Send test email
        </Title>
        <div className="row">
          <div className="col-xs-12">
            <Input label="To" intlKey="label.to" name="email" />
          </div>
          <div className="col-xs-12">
            <Input
              label="Cc"
              intlKey="label.cc"
              name="copyEmails"
              optional
              placeholder={intl.formatMessage({
                id: 'label.use_comma_for_multiple_entries',
                defaultMessage: 'Use comma for multiple entries'
              })}
            />
          </div>
          <div className="col-xs-12">
            <Input label="Subject" intlKey="label.subject" name="subject" />
          </div>
          <div className="col-xs-12">
            <Textarea label="Message" intlKey="label.message" name="body" />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <Button
              type="button"
              intlKey="button.close"
              onClick={this.props.onCancel}
              secondary
            >
              Close
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button isLoading={submitting} intlKey="button.send">
              Send
            </Button>
          </div>
        </div>
      </Form>
    )
  }
}

export default EmailSend
